import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType } from 'react-router-dom';

// Инициализация Sentry только в production режиме
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://944411431d8b4eefabfd55d5da52c2f3@s.secret-agents.ru/48',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 1.0,
    release: 'event-front@production',
    environment: 'production'
  });
}

export const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
